import * as React from 'react'

export interface DialogContext {
  dismissible: boolean
  open: boolean
  setOpen: (open: boolean) => void
}

export const DialogContext = React.createContext<DialogContext | null>(null)

export function useDialogContext() {
  const context = React.useContext(DialogContext)
  if (!context) {
    throw new Error('useDialogContext must be used within <DialogProvider>')
  }
  return context
}
